/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Droplinklabel2Inputs */

const en_droplinklabel2 = /** @type {(inputs: Droplinklabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linked to`)
};

const de_droplinklabel2 = /** @type {(inputs: Droplinklabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verknüpft mit`)
};

/**
* | output |
* | --- |
* | "Linked to" |
*
* @param {Droplinklabel2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const droplinklabel2 = /** @type {((inputs?: Droplinklabel2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Droplinklabel2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_droplinklabel2(inputs)
	return de_droplinklabel2(inputs)
});
export { droplinklabel2 as "dropLinkLabel" }